// extracted by mini-css-extract-plugin
export var textReviews = "textReviews-module--text-reviews--f816c";
export var textReviews__btn = "textReviews-module--text-reviews__btn--effc3";